import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { onLinkClick } from './Link';
import { on } from './Root';
import { scopeLinksContainerAttribute, clickedLink } from './history';

export default class LinksContainer extends React.Component {
  unbindClicks?: () => void;
  componentDidMount() {
    const node = ReactDOM.findDOMNode(this) as Element;
    node.setAttribute(scopeLinksContainerAttribute, 'true');

    this.unbindClicks = on('click', e => {
      const event = (e as any) as React.MouseEvent<HTMLElement>;
      const link = clickedLink(event.nativeEvent);
      if (link && !event.isDefaultPrevented() && isChildOf(link, node)) {
        onLinkClick(link, event as React.MouseEvent<HTMLAnchorElement>);
      }
    });
  }
  componentWillUnmount() {
    if (this.unbindClicks) {
      this.unbindClicks();
    }
  }
  render() {
    return React.Children.only(this.props.children);
  }
}

function isChildOf(child: Element, parent: Element) {
  let current: Element | null = child;
  while (current) {
    if (current === parent) {
      return true;
    }
    current = current.parentElement;
  }
  return false;
}
